import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconTranslationRemoved = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24" sx={{ fill: 'none', ...props.sx }}>
    <path
      d="M1.97046 7.659L13.9824 7.659"
      stroke="#FF3333"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M10.9913 7.75397C10.049 13.3461 6.84242 15.9926 1.96681 16.1561"
      stroke="#FF3333"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M5.71241 10.9333C7.81397 14.7129 9.90419 15.8083 13.6613 16.0849"
      stroke="#FF3333"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M7.22638 7.65766L7.22505 8.40766L8.72505 8.41032L8.72637 7.66032L7.22638 7.65766ZM8.73071 5.21135C8.73145 4.79714 8.39625 4.46076 7.98204 4.46002C7.56783 4.45929 7.23145 4.79448 7.23071 5.20869L8.73071 5.21135ZM8.72637 7.66032L8.73071 5.21135L7.23071 5.20869L7.22638 7.65766L8.72637 7.66032Z"
      fill="#FF3333"
    />
    <path
      d="M10.874 22.004L12.4489 18.7872M20.8042 22.004L19.1963 18.7872M12.4489 18.7872L15.7877 11.9677L19.1963 18.7872M12.4489 18.7872H19.1963"
      stroke="#FF3333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.7408 6.24264L21.9834 2"
      stroke="#FF3333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.7408 2.00004L21.9834 6.24268"
      stroke="#FF3333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
)
